import { sales } from './role'

export const queries = {
  sales,
}
export default queries
